import emiter, { _EVENTS } from '../../../events';
import { _APIS } from 'apis';
import request from 'request';
import {message, Modal} from "antd";


export const useTakeTheLead = () => {

  const search = (params: any) => request.get(_APIS.ACTIVES.TAKE_THE_LEAD.LIST,  {
    params
  })

  const getDetail = (params: any) => request.get(_APIS.ACTIVES.TAKE_THE_LEAD.DETAIL, { params });

  const edit = (params: any) => request.post(_APIS.ACTIVES.TAKE_THE_LEAD.EDIT, params);

  const updateStatus = (params: any) => request.post(_APIS.ACTIVES.TAKE_THE_LEAD.UPDATE_STATUS, params);


  const getDrawerDetail = async (data: any) => {
    if (data.reg_code) {
      const res = await getDetail({
        reg_code: data.reg_code,
      })
      return res.data
    }
    return {}
  }

  const tableActionEdit = async (data: any) => {
    const res = await getDrawerDetail(data)
    emiter.emit(_EVENTS.ACTIVES.TAKE_THE_LEAD.EDIT, {
      ...res,
      drawerInfo: {
        disabled: false,
        title: '编辑'
      }
    });
  }

  const tableActionView = async (data: any) => {
    const res = await getDrawerDetail(data)
    emiter.emit(_EVENTS.ACTIVES.TAKE_THE_LEAD.EDIT, {
      ...res,
      drawerInfo: {
        disabled: true,
        title: '查看'
      }
    });
  }

  const tableActionAdd = (data: any) => {
    emiter.emit(_EVENTS.ACTIVES.TAKE_THE_LEAD.ADD, {
      ...data,
      drawerInfo: {
        disabled: false,
        title: '报名参与'
      }
    });
  }

  const tableActionOut = (data: any) => {
    Modal.confirm({
      centered: true,
      title: `确认是否退出${data.discount}卡位` ,
      okText: '确认',
      cancelText: '取消',
      onOk: async () => {
        await updateStatus({
          ...data,
          reg_code: data.reg_code,
          status: 2,
        })
        message.success('操作成功');
        emiter.emit(_EVENTS.ACTIVES.TAKE_THE_LEAD.SEARCH, {});
      },
    });
  }

  const drawerSubmit = async (data: any, echoData: any) => {
    await edit({
      ...data,
      reg_code: echoData.reg_code || '',
      grab_top_code: echoData.grab_top_code
    })
    message.success('操作成功');
    emiter.emit(_EVENTS.ACTIVES.TAKE_THE_LEAD.SEARCH, {});
  }


  return {
    search,
    edit,
    updateStatus,
    tableActionEdit,
    tableActionAdd,
    tableActionOut,
    tableActionView,
    drawerSubmit
  }
};
